import {ClassOf} from "../types/class-of.type";
import {DynamicLoadHandler} from "../dynamic-loading/dynamic-load-handler.interface";
import {DynamicLoadHandlerDecoratorOptions} from "./dynamic-load-handler-decorator-options.interface";
import {container} from "tsyringe";

/** A class decorator: it receives the handler class and registers it under the hook name. */
type ClassDecoratorFunction = (constructor: ClassOf<DynamicLoadHandler>) => void;

export function dynamicLoadHandler(options: DynamicLoadHandlerDecoratorOptions): ClassDecoratorFunction {

    return function (
        constructor: ClassOf<DynamicLoadHandler>
    ): void {
        container.register(options.hookName, {useToken: constructor});
    }

}